import { createContext } from '@backyard-ui/utils';

import { type CategoryPageData } from '@/infra/services/search/get-facets/models';

interface AlgoliaFacetsProvider {
  indexName: string;
  algoliaFacets?: CategoryPageData['algoliaFacets'];
  isCategoryPage: boolean;
}

const { Provider: ServerProvider, useContext: useServerContext } =
  createContext<AlgoliaFacetsProvider>({
    name: '@store/search/algolia-facets',
  });

export { ServerProvider, useServerContext };
